import { useRef, useState } from "react";
import { Popover } from "web-ui";

import LinkPill from "components/common/LinkPill";
import styles from "components/common/LinkPillWithPopover.module.scss";

interface Props {
  /** Centering the popover content is dependenct on a fixed linkPillWidth
   * should account for the width of the title string and be in px format
   */
  linkPillWidth: string;

  /** Title displayed on the Link Pill */
  linkPillTitle: string;

  /** Content to be displayed inside the Popover */
  popoverContent: JSX.Element;
}

export const LinkPillWithPopover = ({
  linkPillWidth,
  linkPillTitle,
  popoverContent,
}: Props): JSX.Element => {
  const [showPopover, setShowPopover] = useState(false);
  const [isMouseOverPopover, setIsMouseOverPopover] = useState(false);

  const hidePopoverTimeoutId = useRef<number | null>(null);

  const handleMouseEnter = () => {
    // Clear any existing timeout to hide the popover
    if (hidePopoverTimeoutId.current) {
      clearTimeout(hidePopoverTimeoutId.current);
      hidePopoverTimeoutId.current = null;
    }
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    // Start a timeout to hide the popover, allowing time for the user to move to the popover
    hidePopoverTimeoutId.current = window.setTimeout(() => {
      if (!isMouseOverPopover) {
        setShowPopover(false);
      }
    }, 500);
  };

  const handlePopoverEnter = () => {
    setIsMouseOverPopover(true);
    if (hidePopoverTimeoutId.current) {
      clearTimeout(hidePopoverTimeoutId.current);
      hidePopoverTimeoutId.current = null;
    }
  };

  const handlePopoverLeave = () => {
    setIsMouseOverPopover(false);
    setShowPopover(false);
  };

  return (
    <div style={{ position: "relative", width: linkPillWidth }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <LinkPill label={linkPillTitle} />
      </div>
      {showPopover && (
        <div
          onMouseEnter={handlePopoverEnter}
          onMouseLeave={handlePopoverLeave}
        >
          <Popover className={styles.popover} direction="down" zIndex={1}>
            {popoverContent}
          </Popover>
        </div>
      )}
    </div>
  );
};

export default LinkPillWithPopover;
